import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { connect } from 'react-redux'
import { aquasysPath } from '../../conf/basepath'
import DtoUser from '../dto/DtoUser'

const $ = window.$

class Help extends Component {

	open = e => {
		e.preventDefault()
		$('div.tap-target').tapTarget('open')
		$('.tap-target-wrapper.open').css('bottom', '-349px')
	}

	close = e => {
		e.preventDefault()
		$('div.tap-target').tapTarget('close')
	}

	getUserParams = () => {
		if (this.props.user) {
			return `?email=${ this.props.user.email }&lastname=${ this.props.user.lastName }&firstname=${ this.props.user.firstName }`
		}
		return ''
	}

	render() {
		return (
			<div>
				<div className='fixed-action-btn'>
					<a id='menu' className='btn btn-floating btn-large secondary-color-back' onClick={ this.open }>
						<i className='material-icons'>help</i>
					</a>
				</div>
				<div className='tap-target ' data-activates='menu'>
					<div className='tap-target-content tap-target-utils'>
						<div className='margin-top-10'>
							<div className='row'>
								<div className='col offset-s5 center'>
									<a className='btn btn-small modal-trigger' href='#tutorial'>
										{ i18n.tutorial }
									</a>
								</div>
							</div>
							<div className='row'>
								<div className='col offset-s3 center'>
									<a className='btn btn-small center' target='_blank'
									   href={ `${aquasysPath}/aquadb/contact/${this.getUserParams()}` }>
										{ i18n.contactUs }
									</a>
								</div>
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s9 center margin-top-10'>
								<a href={ `${aquasysPath}/legal` } target='_blank'
								   className='font-white'>{ i18n.legalNotice }</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

Help.propTypes = {
	user: PropTypes.objectOf(DtoUser)
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user
	}
}
export default connect(mapStateToProps)(Help)



// WEBPACK FOOTER //
// ./src/home/components/Help.js